import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import theme from './theme';
import GlobalStyles from './global';

/**
 * ThemeProvider - Provedor de tema para styled-components
 *
 * Envolve a aplicação e disponibiliza os tokens de design
 * para todos os componentes filhos.
 *
 * Uso nos componentes:
 * ```javascript
 * const Button = styled.button`
 *   background: ${({ theme }) => theme.colors.primary.gradient};
 *   padding: ${({ theme }) => theme.spacing.md};
 *   border-radius: ${({ theme }) => theme.borderRadius.md};
 * `;
 * ```
 */
export const ThemeProvider = ({ children }) => (
  <StyledThemeProvider theme={theme}>
    <GlobalStyles />
    {children}
  </StyledThemeProvider>
);

export default ThemeProvider;
